export default "__VITE_ASSET__10038de6__"